export default __webpack_public_path__ + "static/media/himalayas-2.0bd3c60d.JPG";